// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _CommentOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/CommentOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var CommentOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _CommentOutlined.default
    }));
};
/**![comment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik01NzMgNDIxYy0yMy4xIDAtNDEgMTcuOS00MSA0MHMxNy45IDQwIDQxIDQwYzIxLjEgMCAzOS0xNy45IDM5LTQwcy0xNy45LTQwLTM5LTQwem0tMjgwIDBjLTIzLjEgMC00MSAxNy45LTQxIDQwczE3LjkgNDAgNDEgNDBjMjEuMSAwIDM5LTE3LjkgMzktNDBzLTE3LjktNDAtMzktNDB6IiAvPjxwYXRoIGQ9Ik04OTQgMzQ1YTM0My45MiAzNDMuOTIgMCAwMC0xODktMTMwdi4xYy0xNy4xLTE5LTM2LjQtMzYuNS01OC01Mi4xLTE2My43LTExOS0zOTMuNS04Mi43LTUxMyA4MS05Ni4zIDEzMy05Mi4yIDMxMS45IDYgNDM5bC44IDEzMi42YzAgMy4yLjUgNi40IDEuNSA5LjRhMzEuOTUgMzEuOTUgMCAwMDQwLjEgMjAuOUwzMDkgODA2YzMzLjUgMTEuOSA2OC4xIDE4LjcgMTAyLjUgMjAuNmwtLjUuNGM4OS4xIDY0LjkgMjA1LjkgODQuNCAzMTMgNDlsMTI3LjEgNDEuNGMzLjIgMSA2LjUgMS42IDkuOSAxLjYgMTcuNyAwIDMyLTE0LjMgMzItMzJWNzUzYzg4LjEtMTE5LjYgOTAuNC0yODQuOSAxLTQwOHpNMzIzIDczNWwtMTItNS05OSAzMS0xLTEwNC04LTljLTg0LjYtMTAzLjItOTAuMi0yNTEuOS0xMS0zNjEgOTYuNC0xMzIuMiAyODEuMi0xNjEuNCA0MTMtNjYgMTMyLjIgOTYuMSAxNjEuNSAyODAuNiA2NiA0MTItODAuMSAxMDkuOS0yMjMuNSAxNTAuNS0zNDggMTAyem01MDUtMTdsLTggMTAgMSAxMDQtOTgtMzMtMTIgNWMtNTYgMjAuOC0xMTUuNyAyMi41LTE3MSA3bC0uMi0uMUEzNjcuMzEgMzY3LjMxIDAgMDA3MjkgNjc2Yzc2LjQtMTA1LjMgODguOC0yMzcuNiA0NC40LTM1MC40bC42LjRjMjMgMTYuNSA0NC4xIDM3LjEgNjIgNjIgNzIuNiA5OS42IDY4LjUgMjM1LjItOCAzMzB6IiAvPjxwYXRoIGQ9Ik00MzMgNDIxYy0yMy4xIDAtNDEgMTcuOS00MSA0MHMxNy45IDQwIDQxIDQwYzIxLjEgMCAzOS0xNy45IDM5LTQwcy0xNy45LTQwLTM5LTQweiIgLz48L3N2Zz4=) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(CommentOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'CommentOutlined';
}
var _default = RefIcon;
